import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Box,
  Breadcrumbs,
  Card,
  TextField,
  Button,
  Link,
  Paper,
  MenuItem,
  Stack,
  TableContainer,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import Appbar from "../../components/Appbar";
import DrawerUI from "../../components/Drawer";
import Body from "../../layout/Body";
import { userDetailAction } from "../../redux/toolkit/users/userDetail";
import {
  userTransactionsAction,
  resetData,
} from "../../redux/toolkit/users/userTransactions";
import { useStyles } from "../../theme/theme";
import { Link as LinkRRD } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";

import { dateFormatStartFun } from "../../helper/dateConverter";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import { singlePublisherUserAction } from "../../redux/toolkit/users/parternUsers";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import Box from '@mui/material/Box';
import InputLabel from "@mui/material/InputLabel";
import { DatePicker } from "@mui/x-date-pickers";
import { render } from "@testing-library/react";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";

import { getAllAppAction } from "../../redux/toolkit/app/getAllApp";
import AmountByAdmin from "./AmountByAdmin";
import { userAttemptedSurveyAction } from "../../redux/toolkit/users/userAttemptedSurvey";
import { singleUserWithdrawAction } from "../../redux/toolkit/users/singleUserWidhrawTransaction";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={<NavigateNextIcon sx={{ color: "#fff" }} fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link underline="hover" sx={{ color: "#fff" }} color="inherit" href="/">
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#fff" }}
        color="inherit"
        href="/publisher"
      >
        User
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#fff" }}
        color="inherit"
        href="/publisher-detail"
      >
        User Details
      </Link>
    </Breadcrumbs>
    <Typography variant="h5">User Attempted Survey</Typography>
  </Stack>
);

const SingleUserWidthdrawTransaction = () => {
 
    const dispatch = useDispatch();
    const query = new URLSearchParams(window.location.search);
    const p_user_id = query.get('p_user_id');
    const publisher_id = query.get('publisher_id');
    console.log(query)
    const [publisher, setPublisher] = useState(null);
    const [app, setApp] = useState(null);
    const [partner, setPartner] = useState(null);
  
    const [open, setOpen] = useState(false);
  
    // const userAttemptedSurvey = useSelector((state) => state.userAttemptedSurvey);
    // const {
    //   data: userAttemptedSurveyData,
    //   loading: usersDetailsLoading,
    //   total,
    // } = userAttemptedSurvey;


    const singleUserWidthDrawTransaction = useSelector((state) => state.singleUserWidthdrawTransaction);

     const {
      data: singleUserWidthDrawTransactionData,
      loading: singleUserWidthDrawTransactionLoading,
      total,
    } = singleUserWidthDrawTransaction;


  
    const [date, setDate] = useState({
      startDate: null,
      endDate: null,
    });
  
    
    const getPublisherSelector = useSelector((state) => state.getPublisher);
    const { data: publiserData } = getPublisherSelector;
  
    const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);
    const { data: partnerData } = partnerDetails;
  
    const appsData = useSelector((state) => state.appAllList);
    const { data: app_data } = appsData;
  
    const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  
    const classes = useStyles();
  
    // const missionDetailsColumn = [
    //   {
    //     field: "s_no",
    //     headerName: "S. No.",
    //     filterable: false,
    //     flex: 1,
    //     minWidth: 50,
    //     headerClassName: "super-app-theme--header",
    //     // renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
    //     renderCell: (params) => {
    //       const { page, pageSize } = pageState;
    //       const serialNumber =
    //         page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
    //       return serialNumber;
    //     },
    //   },
    //   {
    //     field: "appId",
    //     headerName: "App Id",
    //     flex: 1,
    //     minWidth: 250,
    //     headerClassName: "super-app-theme--header",
    //   },
    //   {
    //     field: "surveyId",
    //     headerName: "surveyId",
    //     flex: 1,
    //     minWidth: 250,
    //     headerClassName: "super-app-theme--header",
    //   },
    //   {
    //     field: "partnerId",
    //     headerName: "partnerId",
    //     flex: 1,
    //     minWidth: 250,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       return params.row.earnings ? params.row.earnings : params.row.earnings;
    //     },
    //   },
  
    //   {
    //     field: "p_user_id",
    //     headerName: "p_user_id",
    //     flex: 1,
    //     minWidth: 250,
    //     headerClassName: "super-app-theme--header",
    //   },
  
    //   {
    //     field: "userId",
    //     headerName: "userId",
    //     flex: 1,
    //     minWidth: 250,
    //     headerClassName: "super-app-theme--header",
    //   },
  
    //   {
    //     field: "ip",
    //     headerName: "IP",
    //     flex: 1,
    //     minWidth: 150,
    //     headerClassName: "super-app-theme--header",
    //   },
  
    //   {
    //     field: "raw_amount",
    //     headerName: "Raw Amount",
    //     flex: 1,
    //     minWidth: 170,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       return params.row.raw_amount
    //         ? Number(params.row.raw_amount)?.toFixed(4)
    //         : "---";
    //     },
    //   },
    //   {
    //     field: "user_payout",
    //     headerName: "User Payout",
    //     flex: 1,
    //     minWidth: 170,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       return params.row.user_payout
    //         ? Number(params.row.user_payout)?.toFixed(4)
    //         : "---";
    //     },
    //   },
    //   {
    //     field: "publisher_payout",
    //     headerName: "Publisher Payout",
    //     flex: 1,
    //     minWidth: 170,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       return params.row.publisher_payout
    //         ? Number(params.row.publisher_payout)?.toFixed(4)
    //         : "---";
    //     },
    //   },
    //   {
    //     field: "bonus_amt",
    //     headerName: "Bonus Amount",
    //     flex: 1,
    //     minWidth: 170,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       return params.row.bonus_amt
    //         ? Number(params.row.bonus_amt)?.toFixed(4)
    //         : "---";
    //     },
    //   },
    //   {
    //     field: "trans_id",
    //     headerName: "Transition Id",
    //     flex: 1,
    //     minWidth: 350,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       // return params.row.trans_id ? params.row.trans_id : "---";
    //       <Typography component="div">
    //         <div
    //           style={{
    //             whiteSpace: "normal",
    //             wordBreak: "break-word",
    //             overflowWrap: "break-word",
    //             lineHeight: 1.4,
    //             width: "100%",
    //           }}
    //         >
    //           {params?.row?.trans_id}
    //         </div>
    //       </Typography>;
    //     },
    //   },
  
    //   {
    //     field: "status",
    //     headerName: "Status",
    //     flex: 1,
    //     minWidth: 100,
    //     headerClassName: "super-app-theme--header",
    //   },
  
    //   {
    //     field: "clicked_on",
    //     headerName: "Created At",
    //     flex: 1,
    //     minWidth: 250,
    //     headerClassName: "super-app-theme--header",
    //     renderCell: (params) => {
    //       return moment(params?.row?.clicked_on)
    //         .local()
    //         .format("DD-MM-YYYY hh:mm:ss A");
    //     },
    //   },
    // ];
  



     const missionDetailsColumn = [
        {
          field: "s_no",
          headerName: "S. No.",
          filterable: false,
          flex: 1,
          minWidth: 50,
          headerClassName: "super-app-theme--header",
          // renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
          renderCell: (params) => {
            const { page, pageSize } = pageState;
            const serialNumber =
              page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
            return serialNumber;
          },
        },
        {
          field: "app_id",
          headerName: "App Id",
          flex: 1,
          minWidth: 250,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return (
              <Typography>
                {params.row.app_id ? params.row.app_id : "---"}
              </Typography>
            );
          }
        },
        {
          field: "publisher_id",
          headerName: "Publisher Id",
          flex: 1,
          minWidth: 250,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return (
              <Typography>
                {params.row.publisher_id ? params.row.publisher_id : "---"}
              </Typography>
            );
          }
        },
    
        // {
        //   field: "surevy_id",
        //   headerName: "Survey Id",
        //   flex: 1,
        //   minWidth: 250,
        //   headerClassName: "super-app-theme--header",
        //   renderCell: (params) => {
        //     return params.row.earnings ? params.row.earnings : params.row.earnings;
        //   },
        // },
    
        {
          field: "user_id",
          headerName: "User ID",
          flex: 1,
          minWidth: 250,
          headerClassName: "super-app-theme--header",
          renderCell:(params)=>{
            return(
              <Typography>{params.row.user_id ? params.row.user_id : "---"}</Typography>
            )
          }
        },
    
        {
          field: "status",
          headerName: "Status",
          flex: 1,
          minWidth: 100,
          headerClassName: "super-app-theme--header",
        },
    
        // {
        //   field: "partnerName",
        //   headerName: "Partner Name",
        //   flex: 1,
        //   minWidth: 150,
        //   headerClassName: "super-app-theme--header",
        // },
    
        {
          field: "raw_amount",
          headerName: "Raw Amount",
          flex: 1,
          minWidth: 170,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return params.row.raw_amount
              ? Number(params.row.raw_amount)?.toFixed(4)
              : "---";
          },
        },
        {
          field: "user_payout",
          headerName: "User Payout",
          flex: 1,
          minWidth: 170,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return params.row.user_payout
              ? Number(params.row.user_payout)?.toFixed(4)
              : "---";
          },
        },
        {
          field: "publisher_payout",
          headerName: "Publisher Payout",
          flex: 1,
          minWidth: 170,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return params.row.publisher_payout
              ? Number(params.row.publisher_payout)?.toFixed(4)
              : "---";
          },
        },
        {
          field: "bonus_amt",
          headerName: "Bonus Amount",
          flex: 1,
          minWidth: 170,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return params.row.bonus_amt
              ? Number(params.row.bonus_amt)?.toFixed(4)
              : "---";
          },
        },
        {
          field: "trans_id",
          headerName: "Trans Id",
          flex: 1,
          minWidth: 200,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            // return params.row.trans_id ? params.row.trans_id : "---";
            return <Typography component="div">
                    <div
                      style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        lineHeight: 1.4,
                        width: '100%',
                      }}
                    >
                      {params?.row?.trans_id}
                    </div>
                  </Typography>
          }
        },
    
        {
          field: "isPending",
          headerName: "Is Pending",
          flex: 1,
          minWidth: 100,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return params.row.isPending ? "True" : "False";
          },
        },
    
        {
          field: "createdAt",
          headerName: "Created At",
          flex: 1,
          minWidth: 250,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return moment(params?.row?.createdAt)
              .local()
              .format("DD-MM-YYYY hh:mm:ss A");
          },
        },
      ];
    const dateWiseUser = () => {
      if (!date?.startDate && !date?.endDate && !app && !publisher && !partner) {
        return;
      }
      dispatch(
        // userAttemptedSurveyAction({
        //   p_user_id: p_user_id,
        //   startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        //   endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        //   page: pageState.page,
        //   limit: pageState.pageSize,
        //   publisher_id: publisher,
        // })

         singleUserWithdrawAction({
          p_user_id: p_user_id,
          startDate:  date?.startDate ? dateFormatStartFun(date?.startDate) : null,
          endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
          page: pageState.page,
          limit: pageState.pageSize,
          publisher_id: publisher_id,
        })
      );
    };
  
    useEffect(() => {
      dispatch(getPublisherAction());
      return () => {
        resetData();
      };
    }, []);

  
    // useEffect
    useEffect(() => {
      dispatch(
        // userAttemptedSurveyAction({
        //   p_user_id: p_user_id,
        //   startDate: null,
        //   endDate: null,
        //   page: pageState.page,
        //   limit: pageState.pageSize,
        //   // app_id: app_id,
        //   partner_id: partner,
        //   publisher_id: publisher_id,
        // })
        singleUserWithdrawAction({
          p_user_id: p_user_id,
          startDate: null,
          endDate: null,
          page: pageState.page,
          limit: pageState.pageSize,
          publisher_id: publisher_id,
        })
        
      );
      return () => {
        dispatch(resetData());
      };
    }, [dispatch, pageState.page, pageState.pageSize]);
  
    return (
      <>
        <Helmet>
          <title>Real Opinion Admin | Single User Withdraw Transaction</title>
        </Helmet>
        <Appbar breadcrumb={breadcrumb} />
        <DrawerUI />
        <Body>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Stack direction="row" spacing={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Min Data/Time"
                  value={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) => {
                    setDate({ ...date, startDate: newValue });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
  
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Max Data/Time"
                  value={date?.endDate}
                  minDate={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) => {
                    setDate({ ...date, endDate: newValue });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
  
              {/* <Stack direction="row">
                <Box sx={{ minWidth: 150 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Partner</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Publisher"
                      onChange={(event) => {
                        setPartner(event.target.value);
                      }}
                    >
                      {partnerData?.map((item, i) => (
                        <MenuItem value={item._id}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack> */}
              {/* 
              <Stack direction="row">
                <Box sx={{ minWidth: 150 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Apps</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Publisher"
                      onChange={(event) => {
                        setApp(event.target.value);
                      }}
                    >
                      {app_data?.map((item, i) => (
                        <MenuItem value={item._id}>{item.app_name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack> */}
  
              {/* <Stack direction="row">
                <Box sx={{ minWidth: 150 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Publisher
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={publisher?.name} // ✅ Correct binding
                      label="Publisher"
                      //   onChange={handleChange} // ✅ Fixes event handling
                      onChange={(event) => {
                        setPublisher(event.target.value);
                      }}
                    >
                      {publiserData?.map((item, i) => (
                        <MenuItem key={i} value={item?._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack> */}
  
              <Button variant="contained" onClick={dateWiseUser}>
                Find Data
              </Button>
            </Stack>
          </Stack>
  
          <Stack
            spacing={2}
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
            alignItems="flex-start"
          >
            {/* <Button variant="contained" onClick={()=>setOpen(true)}>
              Amount By Admin
            </Button> */}
  {/* 
            <Typography direction="row" spacing={1}>
              <strong>Raw Amount:</strong> {totalRawAmount}
            </Typography> */}
          </Stack>
  
          <Card sx={{ mt: 2 }}>
            <TableContainer sx={{ width: "100%" }}>
              <Stack
                direction={"row"}
                justifyContent="space-between"
                alignItems={"center"}
              >
                <Typography sx={{ ml: 3, my: 2 }} variant="h6">
                 Single User Withdraw Transaction
                </Typography>
                <Button variant="contained">Total Widhtdraw Transaction: {total ||  0}</Button>
              </Stack>
  
              <Paper
                sx={{
                  bgcolor: "#fff",
                  "& .super-app-theme--header": {
                    bgcolor: "#071D45",
                    color: "#fff",
                  },
                }}
                elevation={0}
              >
                <DataGrid
                  className={classes.root}
                  getRowHeight={() => "auto"}
                  sx={{ border: 0 }}
                  autoHeight
                  rows={singleUserWidthDrawTransactionData}
                  columns={missionDetailsColumn}
                  getRowId={(row) => row._id}
                  disableSelectionOnClick
                  experimentalFeatures={{ newEditingApi: true }}
                  pagination
                  // pageSize={pageSize}
                  // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowCount={total}
                  rowsPerPageOptions={[25, 50, 100]}
                  disableColumnSelector
                  loading={singleUserWidthDrawTransactionLoading ? <LoadingUI /> : false}
                  components={{
                    NoRowsOverlay: () => <NoDataFound />,
                    Toolbar: GridToolbar,
                  }}
                  page={pageState.page}
                  pageSize={pageState.pageSize}
                  paginationMode="server"
                  onPageChange={(newPage) => {
                    setPageState((old) => ({ ...old, page: newPage }));
                  }}
                  onPageSizeChange={(newPageSize) =>
                    setPageState((old) => ({ ...old, pageSize: newPageSize }))
                  }
                />
              </Paper>
            </TableContainer>
          </Card>
        </Body>
      </>
    );

}

export default SingleUserWidthdrawTransaction
